/*/
 * Form validation
/*/
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('[site-validate]')
		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const formReturnSuccess = form.dataset.success
				const formReturnError = form.dataset.error

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					const invalid = this.querySelector(':invalid')
					invalid.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					})
					setTimeout(() => {
						invalid.focus()
					}, 750);
				} else {
					event.preventDefault()

					button.classList.add('is--loading')
					button.disabled = true

					const data = new FormData(this)
					const options = {
						headers: { 'Content-Type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
					.then(_ => {
						form.reset()
						form.classList.remove('is--validated')

						siteAlert({
							text: formReturnSuccess,
							class: 'alert--i_success',
							seconds: 12000
						})
					}).catch(err => {
						console.error(err)

						siteAlert({
							text: formReturnError,
							class: 'alert--i_error',
							seconds: 7000
						})
					}).finally(_ => {
						setTimeout(() => {
							button.classList.remove('is--loading')
							button.disabled = false
						}, 2000);
					})
				}

				form.classList.add('is--validated')
			}, false)
		})
	})

/*/
 * Textarea auto-resize
/*/
	const siteTextarea = document.querySelector('textarea')

	if (siteTextarea) {
		siteTextarea.style.overflow = 'hidden'
		siteTextarea.style.height = _ => siteTextarea.scrollHeight

		siteTextarea.addEventListener('input', e => {
			siteTextarea.style.height = 'calc((var(--fs-small) * 2) + (1rem * var(--lh-content)))'
			siteTextarea.style.height = `${e.target.scrollHeight}px`
		}, false)

		window.addEventListener('resize', _ => {
			setTimeout(() => {
				siteTextarea.style.height = 'auto'
				siteTextarea.style.height = `${siteTextarea.scrollHeight}px`
			}, 100);
		})
	}
